import script from "./DashboardListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardListItem.vue?vue&type=script&setup=true&lang=js"

import "./DashboardListItem.vue?vue&type=style&index=0&id=8b2b0580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b2b0580"]])

export default __exports__